module.exports = {"211202001":"红旗街道","211202002":"工人街道","211202003":"铁西街道","211202004":"铜钟街道","211202005":"柴河街道","211202006":"岭东街道","211202007":"辽海街道","211202201":"龙山乡","211202401":"铁岭经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211202.json
// module id = 535
// module chunks = 0